<template>
    <div>
        <!-- <div v-if="Names == ''">
                        <Mainlayout></Mainlayout>
                    </div>
                    <div v-else>
                        <MainlayoutLogin></MainlayoutLogin>
                    </div> -->
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 10%; margin-bottom:10%">
                            <h1 class="font-general-sans text-center custom-40px-600">
                                Blogs
                            </h1>
                            <p class="custom-18px-500 text-center mt-3 font-inter font-color-696969" style="color:#696969">Highlight the advantages of personalized interview coaching provided by AI interviewers, including how users <br /> can receive tailored feedback and guidance based on their unique strengths and weaknesses.</p>
                        </div>
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-grey">
            <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;">
                <div class="text-center">
                    <br /><br /><br />
                    <CRow>
                        <CCol sm="12">
                            <CRow>
                                <CCol sm="8">
                                    <CRow class="mt-3">
                                        <CCol sm="6" v-for="item in blog" v-bind:key="item.Id" @click="OpenPreview(item.Id)">
                                            <img v-if="item.filePath !== '' && item.filePath !== null" :src="item.filePath" style="max-width:100%" class="border-16px" />
                                            <img v-else src="../assets/img/defaultbanner.png" style="max-width:100%" class="border-16px" />
                                            <h1 class="custom-20px-600 mt-2 text-left">{{ item.Title }}</h1>
                                            <p class="custom-18px-500 mt-2 text-left"> <span v-html="truncateText(item.Contents)" class="custom-18px-500"></span></p>
                                            <p class="custom-14px-400 mt-2 text-left">{{ item.CreatedDate | moment("DD/MM/YYYY") }}</p>
                                        </CCol>

                                      
                                    </CRow>



                                </CCol>
                                <CCol sm="4">
    
    
                                    <div class="inline-container">
                                        <input type="text" class="custom-input-app" v-model="searchQuery" placeholder="Search...."/>
                                    </div>
                                    <h3 class="custom-24px-600 mt-3 text-left">Recent Posts</h3>
                                    <div v-for="item in filteredLists" v-bind:key="item.Id" @click="OpenPreview(item.Id)">
    
                                        <h4 class="custom-14px-400 mt-1 text-left">{{ item.CreatedDate | moment("DD/MM/YYYY") }}</h4>
    
                                        <div class="custom-18px-500 mt-1 text-left" style="clear:both">{{ item.Title }}</div> <br />
                                        <div style="clear:both"></div>
                                        <hr class="bg-f5f5f5" />
                                    </div>
                                
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
    
                </div>
            </CCol>
        </CCol>
    
    
    
    
    
    
    
    
    
        <CCol sm="12" class="p-1" style="background-size: cover;color: #fff">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 80%;margin: auto;" class="d-sm-down-none">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                                            Sign up now for free and take the first step toward landing your dream job!
                                                                                            </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>
    
                    <CCol sm="12" style="width: 100%;margin: auto;" class="d-md-none">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                                            Sign up now for free and take the <br /> first step toward landing your dream job!
                                                                                            </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>
                </div>
                <br /><br /><br />
            </CCol>
    
    
        </CCol>
    
        <Footerlayout></Footerlayout>
    
    </div>
</template>

<script>
import Vue from "vue";

import AOS from "aos";
import "aos/dist/aos.css";
import { Carousel3d, Slide } from "vue-carousel-3d";
Vue.use(Carousel3d);
import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeaderBlack.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';
import { CCarousel, CCarouselItem } from '@coreui/vue';

Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

export default {
    name: "Login",
    components: {
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard,
        Carousel3d,
        Slide,
        CCarousel,
    CCarouselItem,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,
            blog: [],
            searchQuery: ''
  

        };
    },
   
    created() {
        AOS.init();
    },
    mounted() {
        this.getListBlog();
    },
    computed: {
        filteredLists() {
            const query = (this.searchQuery || '').toLowerCase().trim(); // Ensure searchQuery is a string

            const filtered = this.blog.filter(item => {
                const job = item.Title || ''; // Ensure item.job is a string
                const matchesQuery = query ? job.toLowerCase().includes(query) : true;

                return matchesQuery;
            });

            return filtered;
        },
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            this.$router.push("HowItWork");
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("Blog");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("Blog");
                console.error("Error fetching user info:", error);
            }
        },
        truncateText(text) {
            const maxLength = 100;
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            }
            return text;
        },
        async getListBlog() {
            try {
                this.Busy = true;
                const response = await this.$API.get(this.$ListPublishBlog, {
                    withCredentials: true
                });
                if (response.status === 200) {
                    this.Busy = false;
                    this.blog = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        OpenPreview(id) {
            this.$router.push("PreviewBlog?id=" + id);
        }
    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
.truncate {
  font-size: 18px;
  font-weight:500;
  white-space: nowrap; /* Prevents text from wrapping */
}
</style>